import moment from 'moment';
import style from './styles.module.scss';
import { Badge } from 'src/app/components/Badge';
import Dropdown from 'src/app/components/Dropdown';
import { FiMoreHorizontal } from 'react-icons/fi';
import usePermission from '@/app/hooks/usePermission';
import { t, use } from 'i18next';
import { useClient } from 'jsonapi-react';
import { ModalWarning } from '@/components/custom/modal/modal-warning';
import { useState } from 'react';
import toast from 'react-hot-toast';

export const BannerItem = ({ banner, setOpenDetailsModal, setSelectedBanner, updateBannerStatus, updateList }) => {
  const client = useClient();
  const [showWarning, setShowWarning] = useState(false);

  const handleDelete = async id => {
    try {
      const { error } = await client.delete(`bulletin_boards/${id}`);
      if (error) {
        toast.error(t('bulletinBoards.errorDeleteBanner'));
      } else {
        toast.success(t('bulletinBoards.successDeleteBanner'));
        updateList();
      }
    } catch (error) {
      toast.error(t('bulletinBoards.errorDeleteBanner'));
      console.error(error);
    }
    setShowWarning(false);
  };

  const handlePublish = async id => {
    const payload = {
      'published-at': banner['published-at'] ? null : new Date().toISOString()
    };

    try {
      const { error } = await client.mutate(`bulletin_boards/${id}`, payload, {
        method: 'PUT'
      });
      if (error) {
        banner['published-at'] ? toast.error(t('bulletinBoards.errorUnpublishingBanner')) : toast.error(t('bulletinBoards.errorPublishingBanner'));
      } else {
        banner['published-at'] === null ? toast.success(t('bulletinBoards.successPublishingBanner')) : toast.success(t('bulletinBoards.successUnpublishingBanner'));
        updateBannerStatus(banner.id, payload['published-at']);
      }
    } catch (error) {
      toast.error(t('bulletinBoards.errorPublishingBanner'));
      console.error(error);
    }
  };

  return (
    <>
      <tr className="round-dg__row">
        <th className="round-dg__cell-header round-dg__cell-header--row">
          <div className="flex items-center gap-6">
            <img
              src={banner?.image?.url}
              alt={banner.title}
              className={style.image}
            />
            <span className={style.title}>{banner.title}</span>
          </div>
        </th>
        <td className="round-dg__cell">
          {moment(banner['start-date']).format('DD/MM/YYYY')} a {moment(banner['end-date']).format('DD/MM/YYYY')}
        </td>
        <td className="round-dg__cell">
          {banner.profiles.length > 2 ? (
            <div className={style.profiles}>
              <span className={style.profiles}>
                {banner.profiles
                  .slice(0, 2)
                  .map(profile => profile.name)
                  .join(', ')}{' '}
              </span>

              <div
                className={`badge badge--tiny badge--more`}
                title={`${banner.profiles
                  .slice(2)
                  .map(profile => profile.name)
                  .join(', ')}`}
              >{`+ ${banner.profiles.length - 2}`}</div>
            </div>
          ) : (
            <span className={style.profiles}>{banner.profiles.map(profile => profile.name).join(', ')}</span>
          )}
        </td>
        <td className="round-dg__cell">
          <div className="flex items-center gap-2">
            <input
              className="form__check-input"
              id={`publish-${banner.id}`}
              name={`publish-${banner.id}`}
              type="checkbox"
              checked={!!banner['published-at']}
              onChange={() => handlePublish(banner.id)}
            />
            <label htmlFor={`publish-${banner.id}`}>{banner['published-at'] ? 'Publicado' : 'Despublicado'}</label>
          </div>
        </td>
        <td className="round-dg__cell">
          <Dropdown>
            <Dropdown.Toggle>
              <FiMoreHorizontal />
            </Dropdown.Toggle>

            <Dropdown.Content>
              {usePermission('Editar Mural', 'Mural') ? <Dropdown.Item to={`/banners/novo/${banner?.id}`}>{t('button.edit')}</Dropdown.Item> : null}
              {usePermission('Excluir Mural', 'Mural') ? <Dropdown.Item onClick={() => setShowWarning(true)}>{t('button.delete')}</Dropdown.Item> : null}
              <Dropdown.Item
                onClick={() => {
                  setOpenDetailsModal(true);
                  setSelectedBanner(banner);
                }}
              >
                {t('button.view')}
              </Dropdown.Item>
            </Dropdown.Content>
          </Dropdown>
        </td>
      </tr>
      <ModalWarning
        show={showWarning}
        titleFirstButton="Sim"
        titleSecondButton="Não"
        onClose={() => setShowWarning(false)}
        title={'Você tem certeza que deseja excluir?'}
        description={'Essa ação não poderá ser desfeita'}
        onSubmitFirstButton={() => handleDelete(banner.id)}
        onSubmitSecondButton={() => setShowWarning(false)}
      />
    </>
  );
};
